<h1>
  <ng-content></ng-content>
</h1>